/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Colors {
  Default = 0,
  Yellow = 1,
  Orange = 2,
  Red = 3,
  Purple = 4,
  Blue = 5,
  Pink = 6,
  Gray = 7
}
